export default __webpack_public_path__ + "static/DIN-Pro-Regular-e4dca92d0a62752f23789f44d38b2e04.woff";